module.exports = {
  "zones": {
    "Asia/Dhaka": ["z", {
      "wallclock": 1230768000000,
      "format": "+06/+07",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": 1230746400000,
      "save": 0,
      "rules": "Dhaka"
    }, {
      "wallclock": -576115200000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": -576138600000,
      "save": 0
    }, {
      "wallclock": -862617600000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 23400000,
      "posix": -862637400000,
      "save": 0
    }, {
      "wallclock": -872035200000,
      "format": "+0530",
      "abbrev": "+0530",
      "offset": 19800000,
      "posix": -872058600000,
      "save": 0
    }, {
      "wallclock": -891561600000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 23400000,
      "posix": -891582800000,
      "save": 0
    }, {
      "wallclock": -2524521600000,
      "format": "HMT",
      "abbrev": "HMT",
      "offset": 21200000,
      "posix": -2524543300000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 21700000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Dhaka": [{
      "from": 2009,
      "to": 2009,
      "month": 5,
      "day": [7, 19],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2009,
      "to": 2009,
      "month": 11,
      "day": [7, 31],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};